import { render, staticRenderFns } from "./DsbAdmin.vue?vue&type=template&id=404c2f67&scoped=true&"
import script from "./DsbAdmin.vue?vue&type=script&lang=js&"
export * from "./DsbAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DsbAdmin.vue?vue&type=style&index=0&id=404c2f67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c2f67",
  null
  
)

export default component.exports